import classNames from "classnames";
import React, { Component } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import InfoTooltip from "Shared/InfoTooltip";
import MinusIcon from "src/components/icons/Minus";
import PlusIcon from "src/components/icons/Plus";
import { localizeCurrencyWithDecimals } from "src/utils";
import "./List.scss";

export interface ListItem {
    label: string;
    tooltip?: string;
    value: string | JSX.Element;
}

export interface ListProps {
    className?: string;
    collapsed?: boolean;
    collapsible?: boolean;
    items: ListItem[];
    onClick?: (collapsed: boolean) => void;
    title: string;
    tooltip?: string;
    totalAmount?: number;
    e2eName: string;
}

class List extends Component<ListProps & WithTranslation> {
    public static defaultProps = {
        collapsed: true,
        collapsible: true,
    };

    public render() {
        const { className, collapsed, items, title, tooltip = "", e2eName } = this.props;

        return (
            <ul className={classNames("List", { "List--expanded": !collapsed }, className)} data-e2e={e2eName}>
                <li className="List__title-container">
                    <span className="List__title">
                        {title}
                        {tooltip && this.renderInfoTooltip(tooltip)}
                    </span>
                    {this.renderActionButton()}
                </li>
                {this.renderGroupItems(items)}
            </ul>
        );
    }

    public renderActionButton() {
        const { collapsed, collapsible, totalAmount } = this.props;
        const buttonText = localizeCurrencyWithDecimals(totalAmount);
        const buttonIcon = collapsed ? (
            <PlusIcon className="List__action-icon" />
        ) : (
            <MinusIcon className="List__action-icon" />
        );

        return collapsible ? (
            <button className="List__action" onClick={this.handleActionClick}>
                <span className="List__action-text">{buttonText}</span>
                {buttonIcon}
            </button>
        ) : null;
    }

    public renderGroupItems(items: ListItem[]) {
        return !this.props.collapsible || !this.props.collapsed
            ? items.map((item: ListItem, index: number) => {
                  return (
                      <li className="List__item" key={index}>
                          <span className="List__item-label">
                              {item.label}
                              {item.tooltip && this.renderInfoTooltip(item.tooltip)}
                          </span>
                          <span className="List__item-value">{item.value}</span>
                      </li>
                  );
              })
            : "";
    }

    public renderInfoTooltip(tooltip: string) {
        return (
            <span className="List__info">
                <InfoTooltip place="top" text={tooltip} />
            </span>
        );
    }

    private handleActionClick = () => {
        const { onClick, collapsed } = this.props;
        onClick && onClick(!collapsed);
    };
}

export default withTranslation()(List);
